export default {
  'memberSuspension.notice.title': '会員専用エリア',
  'memberSuspension.notice.heading': '会員機能は一時停止中です',
  'memberSuspension.notice.description':
    '現在、会員機能は一時停止されています。',
  'memberSuspension.notice.contact':
    'ご不明な点は店舗スタッフまでお問い合わせください。',
  'memberSuspension.notice.provider':
    '本サービスは Echoss VIP が提供しています',
  'memberSuspension.register.blocked':
    '登録できません。店舗スタッフまでお問い合わせください。',
  'memberSuspension.login.blocked':
    'ログインできません。店舗スタッフまでお問い合わせください。',
  'memberSuspension.asset.blocked':
    'この会員資格は停止中のため、特典やクーポンを利用できません。',
  'memberSuspension.feature.blocked':
    'この会員は停止中のため、この機能を利用できません。',
} as Record<string, string>;
